@if (card && !card.isDownload) {
    @if (card && !loading) {
        <a
            [attr.aria-labelledby]="`${cardNameId(card)}-title`"
            [attr.aria-describedby]="`${cardNameId(card)}-description`"
            [ngClass]="getCardClasses()"
            [class.card--border]="showBorder"
            [class.card--box-shadow]="showBoxShadow"
            [routerLink]="fullUrl(card)"
            [title]="card.name"
            [id]="cardNameId(card)"
            class="card h-100 benefit-card card--image-{{ imageSize }}"
            href="javascript:void(0)">
            @if (displayImages) {
                @if (imageUrl) {
                    <div class="card-img-wrapper card-img-top">
                        <div class="card-img-front">
                            <img alt="" [src]="imageUrl" class="img-fluid" />
                        </div>
                    </div>
                } @else {
                    <div class="card-img-wrapper card-img-top card-img-placeholder"></div>
                }
            }
            <div class="card-body">
                <div class="card-text">
                    @if (
                        cardType !== 'life-journeys' ||
                        wrapperType === 'keyword-content' ||
                        wrapperType === 'related-content'
                    ) {
                        <div [innerHtml]="getTitle()" class="card-text__sub-title"></div>
                    }
                    <h3 [innerText]="card.name" class="card-title" [id]="`${cardNameId(card)}-title`"></h3>
                    @if (card.description) {
                        <p [innerText]="card.description | limitTo: 175" [id]="`${cardNameId(card)}-description`"></p>
                    }
                </div>
                @if (displayTags) {
                    <div class="card-footer">
                        <core-block-tags
                            [enableLinks]="true"
                            [tags]="(card.tags ?? []).slice(0, 3)"
                            [zone]="card.zone"></core-block-tags>
                    </div>
                }
            </div>
        </a>
    }
}

@if (card && card.isDownload && card.token) {
    @if (card && !loading) {
        <a
            (click)="downloadItem(card.token)"
            [ngClass]="getPillar()"
            [title]="card.name"
            class="card h-100 text-decoration-none"
            href="javascript:void(0)">
            <div class="card-img-wrapper card-img-top">
                <div [ngClass]="pageGradient" class="card-img-front">
                    <img [alt]="card.name" [src]="imageUrl" class="img-fluid" />
                </div>
            </div>
            <div class="card-body">
                <div class="card-text">
                    @if (cardType !== 'life-journeys' && cardType !== 'page') {
                        <div [innerHtml]="getTitle()" class="card-text__sub-title"></div>
                    }
                    <h3 [innerText]="card.name" class="card-title"></h3>
                    @if (card.description) {
                        <p [innerText]="card.description | limitTo: 175"></p>
                    }
                </div>
                @if (displayTags) {
                    <div class="card-footer">
                        <core-block-tags [tags]="card.tags ?? []" [zone]="card.zone"></core-block-tags>
                    </div>
                }
            </div>
        </a>
    }
}

@if (loading) {
    <core-block-card-shimmer></core-block-card-shimmer>
}
